import React,{useEffect} from 'react'
import Header from '../Header/Main'
import Footer from '../Footer/Main'
import ContactUS from '../MenContact/ContactUs'
import Aos from 'aos'

function Main() {

    useEffect(() => {
        window.scrollTo(0,0);
    }, []);

    return (
        <div className="page_wrapper">
            <Header />
            <ContactUS/>
            <Footer />
        </div>
    )
}

export default Main